require('../../modules/core.regexp.escape');
module.exports = require('../../modules/_core').RegExp.escape;


//////////////////
// WEBPACK FOOTER
// /var/www/umem/~/core-js/fn/regexp/escape.js
// module id = 298
// module chunks = 0